(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Vanguard Armory": {
      abilities: [{
        cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
        exhausts: true, label: "Vanguard Armory",
        targets: [],
        program: [
          { op: "chooseDest", varKey: "r1", prompt: "Play the first Recruit token where?" },
          { op: "token", name: "Recruit", n: 1, locVar: "r1" },
          { op: "chooseDest", varKey: "r2", prompt: "Play the second Recruit token where?" },
          { op: "token", name: "Recruit", n: 1, locVar: "r2" },
          { op: "chooseDest", varKey: "r3", prompt: "Play the third Recruit token where?" },
          { op: "token", name: "Recruit", n: 1, locVar: "r3" },
        ],
      }],
    },

    "B.F. Sword": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["order"] }),
      ],
    },

    "Blade of the Ruined King": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["order"] }, { costKillFriendly: true }),
      ],
    },

    "Bonds of Strength": {
      play: [buff("$t1", 1)],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit", friendly: true },
          min: 2,
          max: 2,
          prompt: "Give +1 Might to two friendly units",
        },
      ],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Corina Veraza": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move to a battlefield, play three 1 :rb_might: Recruit unit tokens here",
          targets: [],
          program: [{ op: "token", name: "Recruit", n: 3, loc: "here", exhausted: false }],
          self: true,
          condSpec: { k: "evToBf" },
        },
      ],
    },

    "Eminent Benefactor": {
      triggers: [
        {
          on: "hold",
          optional: false,
          label: "When I hold, play two Gold gear tokens exhausted",
          targets: [],
          program: [{ op: "token", name: "Gold", n: 2, loc: "base", exhausted: true }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Eye of the Herald": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["order"] }),
      ],
      attachedTriggers: [
        {
          on: "move",
          optional: false,
          label: "When I move, play a 1 :rb_might: Recruit unit token here",
          targets: [],
          program: [{ op: "token", name: "Recruit", n: 1, loc: "here", exhausted: false }],
          self: true,
        },
      ],
    },

    "Honest Broker": {
      deathknell: [{ op: "token", name: "Gold", n: 1, loc: "base", exhausted: true }],
    },

    "Laurent Duelist": {},

    "Royal Guard": {
      play: [
        { op: "token", name: "Sand Soldier", n: 1, loc: "here", exhausted: false },
      ],
    },

    "Sacred Shears": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["order"] }),
      ],
      attachedDeathknell: [{ op: "draw", n: 1 }],
    },

    "Sandshifter": {
      play: [{ op: "kill", to: "$t1" }],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit", maxMight: 3, enemy: true },
          prompt: "Kill...",
        },
      ],
    },

    "Trove Golem": { play: [{ op: "token", name: "Gold", n: 4, loc: "base", exhausted: true }] },

    "Guards!": {
      play: [
        {
          op: "may",
          prompt: "Pay 1 Order power to have the Sand Soldier enter ready?",
          then: [
            {
              op: "payCost", varKey: "ready",
              cost: { energy: 0, pips: 1, anyPower: 0, domains: ["order"] },
              skipOnFail: 2,
            },
            { op: "token", name: "Sand Soldier", ready: true },
            { op: "end" },
          ],
        },
        { op: "token", name: "Sand Soldier" },
      ],
    },

    "Trusty Ramhound": {
      selfMightSpecs: [{
        n: 1,
        cond: {
          k: "or",
          conds: [
            { k: "count", spec: { type: "unit", friendly: true, other: true, here: true }, n: 1 },
            {
              k: "and",
              conds: [
                { k: "selfAtBase" },
                { k: "count", spec: { type: "unit", friendly: true, other: true, inBase: true }, n: 1 },
              ],
            },
          ],
        },
      }],
    },

    "Zaun Punk": {
      addCosts: [{
        optional: true,
        cond: null,
        label: "Zaun Punk",
        costKill: { type: "gear" },
        thenTargets: [],
        then: [
          {
            op: "choose", bind: "g", spec: { type: "gear", attached: true },
            prompt: "Kill which gear?",
          },
          { op: "kill", to: "$g" },
        ],
      }],
    },

    "Blood Money": {
      play: [
        {
          op: "option", varKey: "side", prompt: "Kill which unit at a battlefield with 2 Might or less?",
          options: ["An enemy unit", "A friendly unit"],
        },
        {
          op: "if", cond: { k: "varEq", key: "side", value: 0 },
          then: [
            {
              op: "choose", bind: "e", min: 0,
              spec: { type: "unit", enemy: true, atBf: true, maxMight: 2 },
              prompt: "Kill which enemy unit at a battlefield?",
            },
            {
              op: "if", cond: { k: "targetsChosen", bind: "e" },
              then: [
                { op: "kill", to: "$e" },
                { op: "token", name: "Gold", exhausted: true },
              ],
            },
          ],
          else: [
            {
              op: "choose", bind: "f", min: 0,
              spec: { type: "unit", friendly: true, atBf: true, maxMight: 2 },
              prompt: "Kill which friendly unit at a battlefield?",
            },
            {
              op: "if", cond: { k: "targetsChosen", bind: "f" },
              then: [
                { op: "kill", to: "$f" },
                { op: "token", name: "Gold", n: 2, exhausted: true },
              ],
            },
          ],
        },
      ],
    },

    Deathgrip: {
      targets: [
        {
          bind: "k", spec: { type: "unit", friendly: true },
          prompt: "Kill which friendly unit?",
        },
        {
          bind: "t", spec: { type: "unit", friendly: true, notBind: "k" },
          prompt: "Give its Might to which other friendly unit?",
        },
      ],
      play: [
        { op: "setVarMight", varKey: "killed", from: "$k" },
        { op: "kill", to: "$k" },
        { op: "grant", to: "$t", might: { varOf: "killed" }, dur: "turn" },
        { op: "draw", n: 1 },
      ],
    },

    "Drag Under": {
      targets: [{
        bind: "t", spec: { type: "unit", atBf: true },
        prompt: "Kill which unit at a battlefield?",
      }],
      play: [{ op: "kill", to: "$t" }],
      costMods: [{ energyLess: 2, fromZone: "notHand" }],
    },

    "Glasc Mixologist": {
      deathknell: [{
        op: "may",
        prompt: "Play a unit costing at most 3 Energy and 1 power from your trash, ignoring its cost?",
        then: [
          {
            op: "choose", bind: "u", min: 0,
            spec: { type: "unit", zone: "trash", maxEnergy: 3, maxPips: 1 },
            prompt: "Play which unit from your trash, ignoring its cost?",
          },
          { op: "playFrom", to: "$u", waive: "all" },
        ],
      }],
    },

    "Rally the Troops": {
      play: [
        {
          op: "delayed", on: "played", repeat: true, forPlayer: "controller",
          label: "Rally the Troops: buff the unit",
          program: [
            { op: "if", cond: { k: "evType", type: "unit" }, skip: 1 },
            { op: "buff", to: "$ev" },
          ],
        },
        { op: "draw", n: 1 },
      ],
    },

    "Unsung Hero": {
      deathknell: [],
      triggers: [{
        on: "dies",
        self: true,
        label: "Deathknell: I was Mighty, draw 2",
        condSpec: { k: "selfMightAtLeast", n: 5 },
        program: [{ op: "draw", n: 2 }],
      }],
    },

    "Altar of Memories": {
      triggers: [{
        on: "dies",
        optional: true,
        exhaustSelf: true,
        label: "exhaust to draw 1, then a card to the top or bottom of your deck",
        condSpec: {
          k: "and",
          conds: [
            { k: "evSnapshotUnit" },
            { k: "evSnapshotFriendly" },
            { k: "selfReady" },
          ],
        },
        program: [
          { op: "exhaust", to: "source" },
          { op: "draw", n: 1 },
          {
            op: "choose", bind: "c", min: 0, spec: { zone: "hand" },
            prompt: "Put which card on the top or bottom of your Main Deck?",
          },
          {
            op: "if", cond: { k: "targetsChosen", bind: "c" },
            then: [
              {
                op: "option", varKey: "where", prompt: "Top or bottom of your Main Deck?",
                options: ["Top", "Bottom"],
              },
              {
                op: "if", cond: { k: "varEq", key: "where", value: 0 },
                then: [{ op: "toDeck", to: "$c" }],
                else: [{ op: "toDeck", to: "$c", bottom: true }],
              },
            ],
          },
        ],
      }],
    },

    "Rek'Sai, Swarm Queen": {
      triggers: [{
        on: "attack",
        self: true,
        optional: true,
        label: "reveal the top 2, play one, recycle the rest",
        program: [{
          op: "lookTopTake", n: 2, optional: true, public: true, playHere: true,
          prompt: "Play one of them (or none); the rest are recycled",
        }],
      }],
    },

    "Fiora, Worthy": {
      triggers: [{
        on: "becameMighty", you: true, optional: true,
        label: "a unit you control became Mighty: pay 1 Order to ready it",
        program: [
          { op: "payCost", cost: { pips: 1 }, domains: ["order"], skipOnFail: 1 },
          { op: "ready", to: "$ev" },
        ],
      }],
    },

    "Soraka, Wanderer": {
      selfKwSpecs: [{ name: "backline", value: null, cond: { k: "always" } }],
      staticDeathReplace: {
        who: "friendly", scope: "here", excludeSelf: true, lessMightThanSource: true,
        mandatory: true, label: "Soraka, Wanderer",
      },
    },

    Undertitan: {
      play: [{
        op: "grant", spec: { type: "unit", friendly: true, other: true },
        might: 2, dur: "turn",
      }],
      revealTriggers: [{
        fromZone: "deck", label: "revealed from the deck: [Add] 2 Energy",
        program: [{ op: "addResources", res: { energy: 2 } }],
      }],
    },

    "Xin Zhao, Vigilant": {
      entersReadyCond: {
        k: "count",
        spec: { type: "unit", friendly: true, inBase: true, other: true },
        n: 2,
      },
    },

    "Renata Glasc, Industrialist": {
      tokensEnterReady: true,
    },

    "Azir, Sovereign": {
      triggers: [{
        on: "attack", self: true, optional: true,
        label: "move any number of your token units to this battlefield",
        targets: [{
          bind: "t", spec: { type: "unit", friendly: true, token: true }, min: 0, max: 99,
          prompt: "Move which of your token units here?",
        }],
        program: [{ op: "move", to: "$t", dest: "here" }],
      }],
    },
  });
})();
